import type { MeResponse } from '@atlassiansox/asc-stargate';

import {
	useLogMeIn as useLogMeInOriginal,
	AtlSiteType,
} from '@/components/confluence/hooks/use-log-me-in';
import { useConfluenceD0to6 } from '@/components/user-context/helpers/cohorts';
import {
	AisSitesType,
	AvailableProductsResponse,
} from '@/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types';

export interface useLogMeInProps {
	availableProducts: AvailableProductsResponse | null;
	userProfile: MeResponse | null;
}

export const useLogMeInD0to6 = ({
	availableProducts,
	userProfile,
}: useLogMeInProps): {
	userProfileName: string | undefined;
	recentSites: AisSitesType[];
	shouldShowLogMeIn: boolean;
} => {
	const confluenceD0to6 = useConfluenceD0to6();
	const useLogMeInOriginalResponse = useLogMeInOriginal({
		availableProducts,
		userProfile,
		siteType: AtlSiteType.CONFLUENCE,
	});

	const shouldShowLogMeIn = !!confluenceD0to6 && useLogMeInOriginalResponse.shouldShowLogMeIn;

	return {
		userProfileName: useLogMeInOriginalResponse.userProfileName,
		recentSites: useLogMeInOriginalResponse.recentSites,
		shouldShowLogMeIn,
	};
};
